import axiosInstance from "./api";
import TokenService from "./token.service";
import { refreshToken,logout } from "../slices/auth";

const setup = (store) => {

    const { dispatch } = store;

//----------------Request----------------------------------------------------------------------------

    axiosInstance.interceptors.request.use(
        (config) => {

       
        const token = TokenService.getLocalAccessToken();

        if (token) {
            config.headers["Authorization"] = 'Bearer ' + token; 
        }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
  );


//----------------Response----------------------------------------------------------------------------

  
    axiosInstance.interceptors.response.use(
        (res) => {
            return res;
        },
        
        async (err) => {
            const originalConfig = err.config;

            if (!originalConfig) {
                return Promise.reject(err);
            }

            if (originalConfig.url !== "/refreshtoken" && err.response) {
                // Not every 401 body is the kernel's JSON error shape -- an ingress or
                // gateway can answer with HTML or nothing at all. Reading `.message`
                // directly threw a TypeError from inside this handler, which both
                // replaced the original error and skipped the refresh entirely, so an
                // expired session never recovered and every table came back empty.
                const responseData = err.response.data;
                const errorMessage =
                    typeof responseData === "string"
                        ? responseData
                        : String(responseData?.message ?? "");

                // Check if error is Unauthorized else pass on
                if (err.response.status === 401 && errorMessage.includes("token has expired") && !originalConfig._retry) {
                    originalConfig._retry = true;

                    try {
                        const rs = await axiosInstance.post("/refreshtoken", {
                        refreshToken: TokenService.getLocalRefreshToken(),
                        });

                       

                        const accessToken  = rs.data;

                        dispatch(refreshToken(accessToken));
                        TokenService.updateLocalAccessToken(accessToken);

                        return axiosInstance(originalConfig);

                    } catch (_error) {

                       
                        dispatch(logout());
                        return Promise.reject(_error);
                    }
                }
            }

            return Promise.reject(err);
        }
    );


};

export default setup;